import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, CTAGroup } from "@/components/bits";
import { IMAGES, PROJECTS, CONTACT } from "@/lib/site";

const FILTERS = ["All", ...CONTACT.serviceAreas];

export default function Portfolio() {
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.county === filter);

  return (
    <div data-testid="page-portfolio" className="pt-32">
      <header className="mx-auto max-w-[1600px] px-6 pb-16 md:px-12">
        <Reveal>
          <SectionLabel>Portfolio &amp; Projects</SectionLabel>
          <h1 className="mt-8 max-w-5xl font-serif text-5xl font-300 leading-[0.98] md:text-8xl">
            Homes that <span className="italic accent-text">respond</span>.
          </h1>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
            A selection of integration work across the California coast. Each project is designed in close collaboration with the homeowner, builder, and design team.
          </p>
        </Reveal>

        <div className="mt-12 flex flex-wrap gap-3" data-testid="portfolio-filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.replace(/\s/g, "-").toLowerCase()}`}
              onClick={() => setFilter(f)}
              className={`border px-5 py-2 text-[11px] uppercase tracking-[0.2em] transition-all duration-300 ${
                filter === f ? "border-white bg-white text-isav-bg" : "border-white/20 text-white/60 hover:border-white/60"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </header>

      <section className="mx-auto max-w-[1600px] px-6 pb-28 md:px-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 0.07} className={p.size === "tall" ? "lg:row-span-2" : ""}>
              <div className="hover-media group relative h-full overflow-hidden border border-white/10">
                <img
                  src={IMAGES[p.image]}
                  alt={p.title}
                  className={`w-full object-cover ${p.size === "tall" ? "h-full min-h-[420px]" : "aspect-[4/3]"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-isav-bg/90 via-transparent to-transparent opacity-75 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-isav-green">{p.county}</p>
                  <h3 className="mt-2 font-serif text-2xl font-400">{p.title}</h3>
                  <p className="text-sm text-white/55">{p.discipline}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-white/10 bg-isav-bg2 py-24" data-testid="portfolio-cta">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
          <Reveal>
            <h2 className="max-w-3xl font-serif text-4xl font-300 md:text-6xl">Have a project in mind?</h2>
            <div className="mt-10"><CTAGroup /></div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
